import React from 'react';
import { GiftIcon } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    number: 1,
    title: 'Kit de Comunicación con Familias',
    value: '$9.000',
    description: 'Modelos de notas, actas de reunión, informes para padres, guías de orientación familiar, plantillas de entrevista.'
  }, {
    number: 2,
    title: 'Banco de Rúbricas Express',
    value: '$9.000',
    description: '+40 rúbricas listas para todas las áreas, adaptables, con indicadores claros y escala de valoración.'
  }, {
    number: 3,
    title: 'Planificador Visual Anual',
    value: '$9.000',
    description: 'Calendario anual con ejes, contenidos y actividades mapeadas semana a semana. Imprimible en A3.'
  }, {
    number: 4,
    title: 'Protocolos de Intervención Psicopedagógica',
    value: '$9.000',
    description: 'Guías paso a paso para las intervenciones más frecuentes en sala: atención, conducta, lenguaje, motricidad.'
  }, {
    number: 5,
    title: 'Fichas de Seguimiento Individual',
    value: '$9.000',
    description: 'Registro por alumno con indicadores de progreso, observaciones y recomendaciones. Listas para completar e imprimir.'
  }, {
    number: 6,
    title: 'Organizador Docente Digital',
    value: '$9.000',
    description: 'Agenda semanal, checklist de tareas, registro de asistencia, control de materiales. Todo en PDF imprimible.'
  }];
  return <section className="w-full bg-transparent py-8" data-id="element-23">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-24">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 text-center" data-id="element-25">
          🎁 Más los Bonos Estratégicos
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-26">
          {bonuses.map(bonus => <div key={bonus.number} className="bg-[#1A1A1A] p-6 rounded-lg border border-[#D4A843]/30 relative overflow-hidden" data-id="element-27">
              <div className="absolute top-4 right-4" data-id="element-28">
                <GiftIcon className="w-8 h-8 text-[#D4A843]/30" data-id="element-29" />
              </div>
              <div className="mb-3" data-id="element-30">
                <span className="text-sm font-semibold text-[#D4A843]" data-id="element-31">
                  BONO {bonus.number}
                </span>
                <h3 className="text-xl font-bold text-white mt-1" data-id="element-32">
                  🎁 {bonus.title}
                </h3>
              </div>
              <p className="text-gray-300 text-sm mb-4" data-id="element-33">{bonus.description}</p>
              <div className="flex items-center gap-3" data-id="element-34">
                <span className="text-gray-500 line-through text-sm" data-id="element-35">
                  Valor {bonus.value}
                </span>
                <span className="bg-[#D4A843] text-white px-5 py-1.5 rounded-full text-sm font-bold shadow-[0_0_12px_rgba(212,168,67,0.5),0_0_24px_rgba(212,168,67,0.25)]" data-id="element-36">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="flex justify-center mt-6" data-id="element-37">
          <div className="border-2 border-[#D4A843] rounded-full px-8 py-4 text-center shadow-[0_0_15px_rgba(212,168,67,0.4),0_0_30px_rgba(212,168,67,0.2)]" data-id="element-38">
            <p className="text-white text-base md:text-lg font-bold" data-id="element-39">
              Valor de los 6 bonos:{' '}
              <span className="line-through text-gray-400" data-id="element-40">$54.000</span>{' '}
              <span className="text-[#D4A843]" data-id="element-41">AHORA GRATIS</span>
            </p>
            <p className="text-gray-400 text-sm mt-1" data-id="element-42">
              Incluidos en las dos ofertas
            </p>
          </div>
        </div>
      </div>
    </section>;
}